// extracted by mini-css-extract-plugin
export default {"mainContainer":"currencySelector_mainContainer__SVemx"};